import { render, staticRenderFns } from "./RateChallenges.vue?vue&type=template&id=1b5182e4&"
import script from "./RateChallenges.vue?vue&type=script&lang=ts&"
export * from "./RateChallenges.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports